import { BaplieParseResultDto, DataParsersApi } from '../app/api'
import { createApiClient } from '../app/http-client'

class DataParserService {
  httpClient = createApiClient(DataParsersApi)

  parseBaplie = async (baplieFile: File): Promise<BaplieParseResultDto> => {
    const { data } =
      await this.httpClient.integrationApiInternalDataParsersParseBaplieFromFilePost(baplieFile)

    return data
  }
}

const dataParserService = new DataParserService()

export default dataParserService
